
import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { SearchService } from "../../../shared/services/search.service";
import { HideScrollNavService } from "../../../shared/services/hidescrollnav.service";
import { BreadcrumbComponent } from "../../../shared/components/breadcrumb/breadcrumb.component";
import { ProfileComponent } from "../../../shared/components/header/profile/profile.component";
import { ThemeModeComponent } from "../../../shared/components/header/theme-mode/theme-mode.component";
import { CommonSvgIconComponent } from "../../../shared/components/common-svg-icon/common-svg-icon.component";
import { ClickOutsideDirective } from "../../../shared/directive/click-outside.directive";
import { SuperAdminNavService } from "../../../shared/services/superadmin_nav.service";

@Component({
  selector: "app-superadmin-header",
  imports: [CommonSvgIconComponent,
    FormsModule, RouterModule, CommonModule, ClickOutsideDirective,
     ThemeModeComponent, ProfileComponent, BreadcrumbComponent],
  templateUrl: './superadmin-header.component.html',
  styleUrls: ["./superadmin-header.component.scss"]
})

export class SuperadminHeaderComponent {

  public isFlip: boolean = false;
  public isSearchOpen: boolean = false;
  public open: boolean = false;

  constructor(
    public navService: SuperAdminNavService,
    public hideScrollNavService: HideScrollNavService,
    public searchService: SearchService
  ) { }

  sidebarToggle() {
    this.navService.collapseSidebar = !this.navService.collapseSidebar;
  }
}
